// import { useUser } from '@auth0/nextjs-auth0';
// import { WidgetLoginSubscribe } from '@nationgroup/nation-login-widgets';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { APP_URL, NEXT_PUBLIC_LOGIN_STATE_DATE, SHOW_COMMEMORATE, SHOW_RIBBON } from 'src/constants';
import CheckboxForm from 'src/services/member-auth/components/forms/checkbox-form';
// import { WidgetLoginSubscribe } from 'src/services/member-auth/components/widget-test';
// import { WidgetLoginSubscribe } from 'src/services/member-auth/components/widget-login-subscribe';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import useUser from 'src/utils/useUser';
import { WidgetLoginSubscribe } from './widget-login-subscribe';

const ButtonSubscribe = ({ refKey, text = '', className, redirectUrl }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [checkPDPA, setCheckPDPA] = useState(false);
  const [checkCookies, setCheckCookies] = useState(false);
  const router = useRouter();

  const conditionDisabled = Cookies.get('login') === 'success' ? false : !(checkPDPA && checkCookies);
  const nid = Cookies.get('_nid');
  const ga = Cookies.get('_ga');
  const _key = nid ? `${ga} : ${nid}` : `${ga}`;

  const { user } = useUser();
  //   const data = useUser();
  //   const [sessionSevId, setSessionSevId] = useState(null);
  //   const [sectionMember, setSectionMember] = useState({});
  //   useEffect(() => {
  //     const checkUser = async () => {
  //       if (!_.isEmpty(data) && !_.isEmpty(data?.user)) {
  //         const response = await fetch('/api/auth/metadata', {
  //           method: 'GET',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           }
  //         });
  //         if (response.ok) {
  //           const res = await response.json();
  //           localStorage.setItem('login-meta-data', res);
  //           setSectionMember(decryptionClient(res));
  //         }
  //       }
  //     };
  //     const loginMetaData = localStorage.getItem('login-meta-data');
  //     const decryptLoginMetaData = !_.isEmpty(loginMetaData) ? decryptionClient(loginMetaData) : {};
  //     const expireCondition = !_.isEmpty(loginMetaData) ? new Date(decryptLoginMetaData?.expire) < new Date() : true;

  //     if (!_.isEmpty(data) && !_.isEmpty(data?.user)) {
  //       setSessionSevId(decryptionClient(data?.user));
  //       _.isEmpty(loginMetaData) || expireCondition ? checkUser() : setSectionMember(decryptLoginMetaData);
  //     }
  //   }, [data]);
  const decrypUser = user ? decryptionClient(user) : null;
  return (
    <>
      <WidgetLoginSubscribe
        refKey={refKey}
        textButton={text}
        className={className}
        sendDataLayerGlobal={sendDataLayerGlobal}
        DATALAYER_TYPE={DATALAYER_TYPE}
        conditionDisabled={conditionDisabled}
        error={error}
        sessionSevId={decrypUser}
        open={open}
        setOpen={setOpen}
        setError={setError}
        router={router}
        _key={_key}
        nextAuthUrl={APP_URL}
        redirectUrl={redirectUrl}
        isRemoveCookie={true}
        loginStateExpire={Number(NEXT_PUBLIC_LOGIN_STATE_DATE)}
      >
        <CheckboxForm name='pdpaConsent' label={'นโยบายคุ้มครองข้อมูลส่วนบุคคล'} checked={checkPDPA} onChange={e => setCheckPDPA(e.target.checked)} />
        <CheckboxForm name='cookieConsent' label={'นโยบายคุ้มครองข้อมูลการใช้คุกกี้'} checked={checkCookies} onChange={e => setCheckCookies(e.target.checked)} />
      </WidgetLoginSubscribe>
    </>
  );
};

export default ButtonSubscribe;
